<template>
  <div>
    <div class="addcontent">
      <pctop v-show="!isPhone" ref="pctop" @headtop="headpctop"></pctop>
      <div class="content">
        <el-form ref="addmessage" :model="dataForm" :rules="datarules" label-position="top" style="width: 100%;">
          <el-form-item class="labelbox" v-if="typeflag">
            <ul>
              <span class="labelspan">标签类型</span>
              <li v-for="(item, index) in typeList" :key="index"><el-radio v-model="dataForm.leaveWordType" :label="item.dictCode">{{item.dictName}}</el-radio></li>
            </ul>
          </el-form-item>
          <el-form-item class="pubpadding" prop="content">
            <el-input v-model="dataForm.content" type="textarea" placeholder="请写下你的留言" @blur.prevent="blurFun()"/>
          </el-form-item>

          <div ref="customupload" class="imguploadbox" v-show="isImageapprove">
            <el-form-item class="pubpadding pubborderb">
              <CustomUpload ref="customUpload"
                            :id="dataForm.id"
                            :limit="8"
                            :custom-upload-disable="CUploaddisable"
                            :image-list="imageArr"
                            upload-api="/upload/more"
                            delete-image-url="/delete"
                            @imagePath="getImagePath"
                            @uploaded="isUpload"
                            @noFile="noFile"
                            @uploadSuccess="uploadSuccess"/>
            </el-form-item>
          </div>
        </el-form>
        <div class="edit-confirm" ref="editconfirm">
          <a href="javascript:;" class="qx" @click="editbtn()">取消</a>
          <a href="javascript:;" class="fb" @click="confirm()">发表</a>
        </div>
      </div>
    </div>
    <menus v-show="isPhone"></menus>
    <tipcommon :pop-isshow="isshow" :isapprove="isapprove"></tipcommon>
  </div>
</template>

<script type="text/ecmascript-6">
import CustomUpload from '@/components/upload/CustomUpload'
import Menus from '@/views/common/menus'
import Tipcommon from '@/views/common/tipcommon'
import Pctop from '@/views/common/pctop'
export default {
  name: 'addmessage',
  components: {
    Menus,
    CustomUpload,
    Tipcommon,
    Pctop
  },
  data () {
    return {
      dataForm: {
        content: '',
        leaveWordType: ''
      },
      datarules: {
        leaveWordType: [{required: true, message: '请选择标签类型', trigger: 'blur'}],
        content: []
      },
      typeList: [], // 标签列表
      CUploaddisable: false,
      imageArr: [],
      isUploaded: true,
      isImageapprove: false, // 是否允许图片留言
      limitcount: '', // 限制字数,
      isapprove: '', // 是否开启审核
      imagePath: [], // 发表图片参数
      isshow: 'none',
      isPhone: true,
      typeflag: true
    }
  },
  created () {
  },
  mounted () {
    this.settinginfo()
    this.typelist(this.$cookie.get('museumCode'))
    if (this.$cookie.get('typeflag') === 'true') {
      this.typeflag = true
    } else {
      this.typeflag = false
    }
    let _this = this
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
    } else {
      this.isPhone = false
      this.$nextTick(() => {
        _this.$refs.pctop.headerHeight()
      })
    }
  },
  methods: {
    headpctop (val) {
      console.log(val)
    },
    // 获取tab 词典表中的留言类型
    typelist (museumCode) {
      let Url = ''
      if (museumCode !== '') {
        Url = this.$http.adornUrl(`/api/admin/front/dict/parent-museum?parentCode=leaveMessage.type&museumCode=` + museumCode)
      } else {
        Url = this.$http.adornUrl(`/api/admin/front/dict/parent-museum?parentCode=leaveMessage.type`)
      }
      this.$http({
        url: Url,
        method: 'get'
      }).then((res) => {
        if (res.data.rel === true) {
          let data = res.data.data
          this.typeList = data
          if (this.typeList.length === 0 && this.$cookie.get('typeflag')) {
            this.typelist('')
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取留言设置状态
    settinginfo () {
      this.$http({
        url: this.$http.adornUrl(`/api/leave-message/front/setting?museumCode=` + this.$cookie.get('museumCode')),
        method: 'get'
      }).then((res) => {
        if (res.data.status === 200) {
          this.limitcount = res.data.data.limitCount
          this.isImageapprove = res.data.data.approveImage
          this.isapprove = res.data.data.approve
          this.datarules.content = {required: true, min: 1, max: this.limitcount, message: '长度不能超过' + this.limitcount + '个字符', trigger: 'blur'}
        } else {
          this.$message.error(res.message)
        }
      })
    },
    editbtn () {
      this.dataForm.leaveWordType = ''
      this.dataForm.content = ''
      this.dataForm.imagePath = []
      this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode')}})
    },
    // 发表留言
    confirm () {
      if (this.$cookie.get('typeflag') === 'true') {
        if (this.typeList.length > 0) {
          if (this.dataForm.leaveWordType === '') {
            this.tip('请选择标签类型', '150', '40')
            return false
          }
        }
      }
      if (this.dataForm.content === '') {
        this.tip('请填写留言', '150', '40')
      } else if (this.dataForm.content.length > this.limitcount) {
        this.tip('长度不能超过' + this.limitcount + '个字符', '150', '40')
      } else {
        if (!this.isImageapprove) {
          this.$http({
            url: this.$http.adornUrl(`/api/leave-message/front/add`),
            method: 'post',
            data: this.$http.adornData({
              'leaveWordType': this.dataForm.leaveWordType,
              'content': this.dataForm.content,
              'museumCode': this.$cookie.get('museumCode')
            })
          }).then((res) => {
            if (res) {
              if (res.data.rel === true) {
                this.isshow = 'block'
              } else {
                if (res.data.data === '你已被禁言。') {
                  this.$message.error(res.data.data)
                  setTimeout(() => {
                    if (this.$cookie.get('typeflag') === 'false') {
                      this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode'), typeflag: 1, theme: this.$cookie.get('themeName')}})
                    } else {
                      this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode'), theme: this.$cookie.get('themeName')}})
                    }
                  }, 3000)
                } else {
                  this.$message.error(res.data.data)
                }
              }
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.$refs.customUpload.submitUpload()
        }
      }
    },
    noFile () {
      this.uploadfb('')
    },
    uploadfb (pathimg) {
      let pathimgs = ''
      if (pathimg.length > 0) {
        pathimgs = pathimg.join('|')
      } else {
        pathimgs = ''
      }
      this.$http({
        url: this.$http.adornUrl(`/api/leave-message/front/add`),
        method: 'post',
        data: this.$http.adornData({
          'leaveWordType': this.dataForm.leaveWordType,
          'content': this.dataForm.content,
          'imagePath': pathimgs,
          'museumCode': this.$cookie.get('museumCode')
        })
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            this.isshow = 'block'
          } else {
            if (res.data.data === '你已被禁言。') {
              this.$message.error(res.data.data)
              setTimeout(() => {
                this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode')}})
              }, 3000)
            } else {
              this.$message.error(res.data.data)
            }
          }
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    getImagePath (val) {
      // this.imagePath.push(val.http)
    },
    isUpload (val) {
      this.isUploaded = val
    },
    uploadSuccess (val) {
      val.forEach((item) => {
        this.imagePath.push(item.http)
      })
      this.uploadfb(this.imagePath)
    },
    blurFun () {
      setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    }
  },
  watch: {
    imagePath (val) {
      // this.uploadfb(val)
    }
  }
}
</script>

<style lang="scss">
*{touch-action: none;}
.fl{
  float: left;
}
.fr{
  float: right;
}
.addcontent{
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
  .el-radio-group{
    width: 100%;
  }
  .labelbox{
    position: relative;
    margin-bottom: 10px;
    ul{
      &::after{
        content:'';
        display:block;
        clear:both;
        height:0;
        visibility:hidden;
        font-size:0;
      }
      .labelspan{
        width: 12.5%;
        float: left;
        text-align: center;
        padding: 2px 5px;
        color: #999;
        display: block;
        height: 32px;
        font-size: 14px;
        line-height: 32px;
      }
      li{
        width: 12.5%;
        float: left;
        padding: 0 5px;
        margin-bottom: 10px;
        .el-radio{
          display: block;
          border: solid 1px #d7d7d7;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
          text-align: center;
          width: 100%;
          float: none;
          padding: 0px 5px;
          height: 32px;
          line-height: 32px;
          .el-radio__input{
            display: none;
          }
          .el-radio__label{
            padding: 0;
          }
          &.is-checked{
            background: #fff;
            border: solid 1px #fff;
          }
        }
      }
    }
  }
  .el-textarea{
    border-radius: 8px;
    overflow: hidden;
    .el-textarea__inner{
      padding: 15px;
      min-height: 100px;
      border-radius: 8px;
    }
  }
  .imguploadbox{
    background: #fff;
    padding: 15px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    overflow: hidden;
    .el-form-item{
      margin-bottom: 0;
    }
    .el-upload--picture-card{
      width: 100px;
      height: 100px;
      background: #d7d7d7;
      border: none;
      line-height: 100px;
      span{
        display: block;
        position: relative;
        width: 20px;
        height: 20px;
        background: url(../assets/images/icon-imgadd.png) no-repeat;
        background-size: 100% 100%;
        top: 50%;
        left: 50%;
        margin: -10px 0 0 -10px;
      }
    }
    .el-upload-list--picture-card .el-upload-list__item{
      width: 100px;
      height: 100px;
      margin: 0 5px 5px 0;
    }
  }
  .edit-confirm{
    text-align: center;
    padding: 50px 0 0;
    a{
      display: inline-block;
      background: #d7d7d7;
      color:#fff;
      padding: 4px 30px;
      border-radius: 8px;
      margin: 0 20px;
      &.fb{
        background: #a11b00;
      }
    }
  }
}
.addcontent .content{
  width: 1000px;
  margin: 0 auto;
  padding: 30px 0 ;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: none;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
  border-radius: 4px;
  background-color: none;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, .2);
  background-color: #ddd;
}
@media only screen and ( max-width:768px) {
  .addcontent{
    padding: 20px 15px;
    .labelbox{
      ul{
        .labelspan{
          width: 25%;
          padding: 5px;
          height: 26px;
          line-height: 22px;
        }
        li{
          width: 25%;
          .el-radio{
            height: 26px;
            line-height: 26px;
          }
        }
      }
    }
  }
  .addcontent .content{
    width: 100%;
    padding: 0;
  }
}
.lstheme{
  .addcontent{
    .el-textarea__inner{
      background: #012245;
      border: solid 1px #9fb9d0;
      box-shadow: 0 0 40px rgba(171, 222, 254, 0.5) inset;
      color: #bdd2ed;
    }
    .edit-confirm{
      a{
        border: solid 2px #5297f2;
        border-radius: 20px;
        background: -webkit-linear-gradient(top, #fefefe , #7cbbee);
        background: -o-linear-gradient(bottom, #fefefe, #7cbbee);
        background: -moz-linear-gradient(bottom, #fefefe, #7cbbee);
        background: linear-gradient(to bottom, #fefefe , #7cbbee);
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#fefefe, endColorstr=#7cbbee);
        color: #123764;
      }
    }
    .imguploadbox,
    .el-upload--picture-card{
      background: #012245;
      border: solid 1px #9fb9d0;
      box-shadow: 0 0 40px rgba(171, 222, 254, 0.5) inset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/addmessage.vue